// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Local reset (bootstrap is injected dynamically by ThemeContext)
import 'antd/dist/reset.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/700.css';
// Persian font (Vazirmatn)
import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/700.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);